<ul
    class="language-selector"
    data-application="language-selector"
    [ngClass]="{
        'language-selector--open': isCurrentNavItemOpened,
        'language-selector--withOpenNav': isAnyNavItemOpen,
    }"
>
    <li class="language-selector__wrapper">
        <div class="language-selector__image-container">
            <website-image
                [src]="LANGUAGE_SELECTOR_PATH"
                [alt]="'Language selector dropdown with globe icon and list of available languages.'"
                [width]="600"
                [height]="260"
                [config]="imageConfig"
                class="language-selector__image"
            ></website-image>
        </div>
        <div class="language-selector__language-group">
            @for (languageGroup of languages; track $index) {
                <div class="language-selector__language-group-item">
                    @for (language of languageGroup; track language.slug) {
                        <div>
                            <a
                                [href]="language.url"
                                class="language-selector__language language-selector__language--{{
                                    theme
                                }} language-selector__language--{{ language.slug }}"
                                [innerHTML]="language.name"
                                [tabIndex]="isCurrentNavItemOpened ? 0 : -1"
                            ></a>
                        </div>
                    }
                </div>
            }
        </div>
    </li>
</ul>
